export default "__VITE_ASSET__80dfd018__"